import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as Styles from './sign-in-legal.module.scss';

function SignInLegal({ className }) {
  return (
    <div className={classNames(className, Styles.root, 'container', 'container-sm')}>
      <p>
        By registering and/or logging in, you agree that your use of this TIME for Kids product is subject to our Terms
        of Us and Privacy Policy
      </p>
      <p>&copy;2024 TIME USA, LLC. All Rights Reserved.</p>
    </div>
  );
}

SignInLegal.propTypes = {
  className: PropTypes.string,
};

SignInLegal.defaultProps = {
  className: null,
};

export default SignInLegal;
